__turbopack_context__.v({
  "ExpanderButton": "urvW8q_ExpanderButton",
  "ExpanderIcon": "urvW8q_ExpanderIcon",
  "SExpander": "urvW8q_SExpander",
  "SFacts": "urvW8q_SFacts",
  "SGenre": "urvW8q_SGenre",
  "SInfo": "urvW8q_SInfo",
  "SKinoklubb": "urvW8q_SKinoklubb",
  "SLinks": "urvW8q_SLinks",
  "SMovie": "urvW8q_SMovie",
  "SMovieContainer": "urvW8q_SMovieContainer",
  "SMovieTitle": "urvW8q_SMovieTitle",
  "SNoLink": "urvW8q_SNoLink",
  "SNoWrap": "urvW8q_SNoWrap",
  "SPosterContainerLink": "urvW8q_SPosterContainerLink",
  "SPosterImage": "urvW8q_SPosterImage",
  "SProgram": "urvW8q_SProgram",
  "SReadMoreLink": "urvW8q_SReadMoreLink",
  "STitleLink": "urvW8q_STitleLink",
  "ThemeDk": "urvW8q_ThemeDk",
  "ThemeFw": "urvW8q_ThemeFw",
  "expanded": "urvW8q_expanded",
  "isExpanded": "urvW8q_isExpanded",
});
